import { PgisApi } from "pgi-experience-client";
import { createCommonConfigurationForApis } from "./CommonHelper";
import { spire360ApiClient } from "./Spire360ApiClient";
import axios, { AxiosInstance } from "axios";
import { PGIAssessmentMapping } from "../interfaces/PGIAssessmentMapping";

export function createPgiApi(): PgisApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === 'true';

  if(isGatewayEnabled){
    const basePath = process.env.REACT_APP_PGI_API_URL;
  const axiosInstance: AxiosInstance = spire360ApiClient;
  return new PgisApi(
    undefined,
    `${process.env.REACT_APP_PGI_API_URL_GATEWAY}`,
    axiosInstance

    // "http://localhost:4035"
  );

  }
  else{
  return new PgisApi(
    createCommonConfigurationForApis(),
    `${process.env.REACT_APP_PGI_API_URL}`

    // "http://localhost:4035"
  );
  }

}

// Fetches the flattened assessment -> Problem/Goal/Intervention rules.
// Mirrors createPgiApi()'s gateway/non-gateway split. Uses a direct request because the
// generated PgisApi client does not yet expose pgiControllerGetAssessmentMappings; once the
// PGI experience client is regenerated, this can be swapped for the typed method.
export async function getPGIAssessmentMappings(
  formId?: string,
): Promise<PGIAssessmentMapping[]> {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === 'true';
  const params = formId ? { formId } : undefined;
  const path = "/pgis/assessment-mappings";

  if (isGatewayEnabled) {
    const { data } = await spire360ApiClient.get<PGIAssessmentMapping[]>(
      `${process.env.REACT_APP_PGI_API_URL_GATEWAY}${path}`,
      { params },
    );
    return data;
  }

  const config = createCommonConfigurationForApis();
  const apiKey = await (typeof config.apiKey === "function"
    ? config.apiKey("userid")
    : config.apiKey);
  const { data } = await axios.get<PGIAssessmentMapping[]>(
    `${process.env.REACT_APP_PGI_API_URL}${path}`,
    { params, headers: apiKey ? { userid: apiKey } : undefined },
  );
  return data;
}
